import Image from 'next/image';
import styles from './chatCard.module.scss';
import { TimeDifference } from 'scripts';
import { ChatType } from 'types';
import { TbCamera } from 'react-icons/tb';

const imageFormats = ['.png', '.jpg', '.jpeg', '.webp', '.svg'];

function ChatCardComp({
    className,
    data,
    onClick,
}: {
    className?: string;
    data: ChatType;
    onClick: (e: number) => void;
}) {
    const mainImage =
        data.post.main_image?.file ??
        data.post.gallery?.filter((i) => imageFormats.map((j) => i.file.toLowerCase().endsWith(j)).includes(true)).at(0)
            ?.file;
    const mainVideo = data.post.gallery
        ?.filter((i) =>
            ['.mp4', '.webm', '.ogg', '.avi', '.ogv', '.mkv', '.3gp', '.mpeg']
                .map((j) => i.file.toLowerCase().endsWith(j))
                .includes(true),
        )
        .at(0)?.file;
    return (
        <div
            className={`${styles['chat-card-layout']} d-flex g-1 center-content-y p-1 ${className} pointer`}
            onClick={() => onClick(data.id)}
        >
            <div className={`${styles['image']}`}>
                {mainImage?.length ? (
                    <Image src={mainImage} width={119} height={106} alt={data.post.title} />
                ) : mainVideo?.length ? (
                    <video
                        src={mainVideo}
                        controls={false}
                        onContextMenu={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            return false;
                        }}
                    />
                ) : (
                    <div className={`w-100 h-100 center-content bg-bgLight bg-d-bgDark ${styles['no-img']}`}>
                        <TbCamera size={32} className="t-l-gray1" />
                    </div>
                )}
            </div>
            <div className="w-100">
                <div className="flex-between center-content-y">
                    <p className="t-p1 t-400 t-l-black1">{data.post.title}</p>
                    <p className="t-p3 t-400 t-l-gray1">
                        {TimeDifference(data.last_message?.created_at ?? data.created_at ?? '')}
                    </p>
                </div>
                <div className="flex-between center-content-y g-1">
                    <p className={`${styles['last-message']} t-p3 t-400 t-l-gray1`}>
                        {data.last_message?.text === '____ALOEJARE_VOICE_MESSAGE____'
                            ? 'پیام صوتی'
                            : (data.last_message?.text ?? 'پیامی هنوز ارسال نشده است')}
                    </p>
                    {data.unread_messages ? (
                        <span className={`${styles['counter']} center-content`}>
                            <p className="t-white-i">{data.unread_messages}</p>
                        </span>
                    ) : null}
                </div>
            </div>
        </div>
    );
}

export default ChatCardComp;
